module.exports = __webpack_public_path__ + "static/media/consultDoctorOnline.ca1b86da.svg";